// extracted by mini-css-extract-plugin
export default {"missionTitle":"AboutUsPage_missionTitle-vF6","missionSubtitle":"AboutUsPage_missionSubtitle-kEQ","missionButton":"AboutUsPage_missionButton-V7p"};